
import { mixins, Options, Prop, Watch } from 'vue-property-decorator'
import { Action } from 'vuex-class'
import { UEFA_ACTION, UEFA_NAMESPACE, UefaScheduleListPayload, UefaScheduleListResult } from '../../store'

import { uefaSeries } from '../components/uefa/config'
import UefaUpcomingList from '../components/uefa/UefaUpcomingList.vue'
import PageLayout from '../layouts/PageLayout.vue'
import WidgetMixin, { WidgetMeta, widgetMetaFields } from './WidgetMixin'

export const meta: WidgetMeta = {
  label: 'UEFA - Közelgő mérkőzések',
  fields: {
    ...widgetMetaFields,
    length: {
      type: Number,
      default: 4,
      props: {
        placeholder: 'Darabszám',
        min: 2
      }
    },
    showSlider: {
      type: Boolean,
      default: false,
      props: {
        label: 'Lapozó'
      }
    },
    fullpageMode: {
      type: Boolean,
      default: false,
      props: {
        label: 'Teljes oldalas'
      }
    },
    streamUrl: {
      type: String,
      default: 'https://rtlplusz.hu',
      props: {
        placeholder: 'Stream url'
      }
    }
  }
}

@Options({
  name: 'UefaUpcomingListWidget',
  components: {
    UefaUpcomingList,
    PageLayout
  }
})
export default class UefaUpcomingListWidget extends mixins(WidgetMixin) {
  @Action(UEFA_ACTION.SCHEDULE_LIST, { namespace: UEFA_NAMESPACE })
  storeFetchUefaScheduleList!: (payload: UefaScheduleListPayload) => Promise<UefaScheduleListResult>

  @Prop({
    type: Number,
    default: 4
  })
  readonly length!: number

  @Prop({
    type: Boolean,
    default: false
  })
  readonly showSlider!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  readonly fullpageMode!: boolean

  @Prop({
    type: String,
    default: 'https://rtlplusz.hu'
  })
  readonly streamUrl!: string

  get filterOptions () {
    return uefaSeries
  }

  get selectedFilter () {
    return this.filterOptions.find((filter) => this.$route?.query['szurok'] === filter.value)
  }

  isFilterSelected (value: string) {
    return this.selectedFilter?.value === value
  }

  toggleFilter (value: string) {
    this.$router.push({ query: !this.isFilterSelected(value) ? { szurok: value } : null })
  }

  get upcomingList () {
    const data = this.$store.getters['$cache/result']([UEFA_NAMESPACE, UEFA_ACTION.SCHEDULE_LIST], this.uefaScheduleListPayload)?.data

    if (data) {
      const now = new Date()
      const getDate = (date: string, time: string) => {
        return new Date(`${date.endsWith('Z') ? date.slice(0, -1) : date} ${time}`)
      }
      return data.matchDate.flatMap((matchDate: any) => matchDate.match)
        .filter((match: any) => getDate(match.date, match.time) >= now)
        .sort((a: any, b: any) => getDate(a.date, a.time).valueOf() - getDate(b.date, b.time).valueOf())
        .slice(0, this.length)
        .map((match: any) => {
          const matchDate = getDate(match.date, match.time)
          const series = this.filterOptions.findLast((series) => series.tags.findLast((tag) => tag.date < matchDate)) ?? null

          return {
            series: series?.label ?? '',
            items: [
              { name: match.homeContestantName, logo: `${this.$store.getters.getEnv('RTL_URL') ?? ''}/uefa/teams/${match.homeContestantShortName?.replace('/', '-')}.png` },
              { name: match.awayContestantName, logo: `${this.$store.getters.getEnv('RTL_URL') ?? ''}/uefa/teams/${match.awayContestantShortName?.replace('/', '-')}.png` }
            ],
            date: matchDate,
            url: this.streamUrl
          }
        })
    }

    return []
  }

  get upcomingListBySeries () {
    const items = this.upcomingList
    return this.filterOptions.map((series) => {
      return {
        ...series,
        items: items.filter((score: any) => score.series === series.label)
      }
    })
  }

  get uefaScheduleListPayload (): UefaScheduleListPayload {
    return {}
  }

  @Watch('uefaScheduleListPayload', { deep: true })
  async fetchUefaScheduleList () {
    if (this.uefaScheduleListPayload) {
      return this.storeFetchUefaScheduleList(this.uefaScheduleListPayload)
    }
  }

  serverPrefetch () {
    return this.fetchUefaScheduleList()
  }

  mounted () {
    return this.fetchUefaScheduleList()
  }
}
